const MB_TO_KB = 1000;
const KB_TO_BYTE = 1000;

export { KB_TO_BYTE as K, MB_TO_KB as M };
